module.exports = "https://cdn2-fs.clearscore.com/flux/images/6ffa12dc97779fa59c2e4e61f6aa341c.jpg";